// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__PHbR5","rootSuccess":"CompleteLink_rootSuccess__3il2J","rootFailure":"CompleteLink_rootFailure__iDdkd","isDisabled":"CompleteLink_isDisabled__3Jzph"};